import { type PropsWithChildren } from 'react'
import { LosseLayout } from '@ubo/losse-sjedel'
import Footer from './Footer'
import Header from './Header'
import { useUtm } from '~/services/utm'

export default function Layout({ children }: PropsWithChildren<{}>) {
  useUtm()

  return (
    <LosseLayout>
      <Header />
      <main className="min-h-screen pt-[98px] lg:pt-[128px]">{children}</main>
      <Footer />
    </LosseLayout>
  )
}
